import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'

export const ViewerManagerScopesApi = withDependencies(
	[],
	(): IViewerManagerImplementor<'scopes'> => {
		return {
			scopes: {
				getScope(id: string) {
					const comp = document.getElementById(id)
					return comp?.dataset.scope ? comp.dataset.scope.split(',') : []
				},
				getRepeaterItemsIndexes: (id: string) => {
					const comp = document.getElementById(id)
					return comp?.dataset.repeaterItemsIndexes
						? comp.dataset.repeaterItemsIndexes.split(',').map(Number)
						: []
				},
			},
		}
	}
)
